import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  WebDomEcommerceLogo,
  WebDomFintechLogo,
  WebDomHealthcareLogo,
  WebDomEducationLogo,
  DigitalMarketingIndustryRetail,
  DigitalMarketingIndustryFood,
  DigitalMarketingIndustryFashion,
  DigitalMarketingIndustryManu,
  WebDomRealEstateLogo,
  DigitalMarketingIndustryMedia,
  DigitalMarketingIndustryLegal,
  WebDomNonProfitLogo,
  DigitalMarketingIndustryAuto,
  WebDomTourLogo,
  DigitalMarketingIndustryTechnology,
} from "../../../app-constants";

function Domaindiversity() {
  return (
    <section className="domain_diversity digital_marketing_industry p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={18}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>Industries We Serve</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="domain_main">
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomHealthcareLogo}
                  <h6>Healthcare</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomEcommerceLogo}
                  <h6>eCommerce</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomRealEstateLogo}
                  <h6>Real Estate</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomFintechLogo}
                  <h6>Finance & Banking</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {DigitalMarketingIndustryTechnology}
                  <h6>Technology</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomEducationLogo}
                  <h6>Education</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomTourLogo}
                  <h6>Travel</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {DigitalMarketingIndustryAuto}
                  <h6>Automotive</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {DigitalMarketingIndustryRetail}
                  <h6>Retail</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {DigitalMarketingIndustryFood}
                  <h6>Food & Beverage</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {DigitalMarketingIndustryFashion}
                  <h6>Fashion & Apparel</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {DigitalMarketingIndustryManu}
                  <h6>Manufacturing</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {DigitalMarketingIndustryMedia}
                  <h6>Entertainment & Media</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomNonProfitLogo}
                  <h6>Non-Profit</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {DigitalMarketingIndustryLegal}
                  <h6>Legal Services</h6>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Domaindiversity;
